import {
  LOAD_QUALIFICATIONS_SUCCESS,
  LOAD_QUALIFICATIONS_FAILURE,
  LOAD_QUALIFICATION_REQUEST,
  LOAD_QUALIFICATION_SUCCESS,
  LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST,
  LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS,
  LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
  LOAD_DEVELOPER_QUALIFICATIONS_REQUEST,
  LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS,
  LOAD_DEVELOPER_QUALIFICATIONS_FAILURE,
} from '../ActionType';
import * as QualificationAPI from '../../api/QualificationAPI';
import map from 'lodash/map';

export const getQualifications =
  (countryId, languageId, targetingQIDHash) => async (dispatch) => {
    if (targetingQIDHash) {
      dispatch({
        type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST,
        payload: { countryId, languageId },
      });
    }
    try {
      const result = await QualificationAPI.qualificationList(
        countryId,
        languageId
      );
      const qualifications = result.data.data;

      // Build hash for quicker loop up
      const qualificationsHash = qualifications.reduce(
        (curr, elem) => {
          const elemWithId = { ...elem.attributes, id: elem.id };
          curr.questionIdHash[elem.attributes.question_id] = elemWithId;
          curr.qualificationIdHash[elem.id] = elemWithId;
          return curr;
        },
        {
          questionIdHash: {},
          qualificationIdHash: {},
        }
      );
      dispatch({
        type: LOAD_QUALIFICATIONS_SUCCESS,
        payload: { qualifications: qualificationsHash.qualificationIdHash },
      });

      if (targetingQIDHash) {
        try {
          // Build targetQualification
          const targetingQualification = map(targetingQIDHash, (group) => ({
            name: group.name,
            qualifications: group.qids
              .map((id) => qualificationsHash.questionIdHash[id.toString()])
              .filter((data) => data),
          }));

          dispatch({
            type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS,
            payload: { targetingQualification, countryId, languageId },
          });
        } catch (err) {
          dispatch({
            type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
            payload: { error: err.message },
          });
        }
      }
    } catch (e) {
      dispatch({
        type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
        payload: { error: e.message },
      });
    }
  };

export const getQualification = (id) => async (dispatch) => {
  dispatch({ type: LOAD_QUALIFICATION_REQUEST, payload: { id } });
  try {
    const result = await QualificationAPI.get(id);
    dispatch({
      type: LOAD_QUALIFICATION_SUCCESS,
      payload: { qualification: result.data },
    });
  } catch (e) {
    return dispatch({
      type: LOAD_QUALIFICATIONS_FAILURE,
      payload: { error: e.message },
    });
  }
};

export const getQualificationTopics =
  (countryId, languageId) => async (dispatch) => {
    dispatch({
      type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_REQUEST,
      payload: { countryId, languageId },
    });
    try {
      const result = await QualificationAPI.listWithTopics(
        countryId,
        languageId
      );
      // Build targetQualification
      const targetingQualifications = result.data;

      dispatch(
        getQualifications(countryId, languageId, targetingQualifications)
      );
      dispatch({
        type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_SUCCESS,
        payload: { targetingQualifications, countryId, languageId },
      });
    } catch (e) {
      dispatch({
        type: LOAD_CURRENT_TARGETING_BY_COUNTRY_LANGUAGE_FAILURE,
        payload: { error: e.message },
      });
    }
  };

export const getDeveloperQualifications =
  (countryId, languageId) => async (dispatch) => {
    dispatch({ type: LOAD_DEVELOPER_QUALIFICATIONS_REQUEST });
    try {
      const { data: qualifications } =
        await QualificationAPI.getDeveloperQualifications(
          countryId,
          languageId
        );
      dispatch({
        type: LOAD_DEVELOPER_QUALIFICATIONS_SUCCESS,
        payload: { qualifications },
      });
    } catch (e) {
      dispatch({
        type: LOAD_DEVELOPER_QUALIFICATIONS_FAILURE,
        payload: { error: e.message },
      });
    }
  };
